import wrapper from '@/components/Wrapper/MainWrapper.vue';
import BG from '@/assets/main-bg.jpg';
import GAME1_LEVEL1_BG from '@/assets/game1-level1-bg.jpg';
import GAME1_LEVEL2_BG from '@/assets/game1-level2-bg.jpg';
import GAME1_LEVEL3_BG from '@/assets/game1-level3-bg.jpg';

export default {
    components: { wrapper },
    methods: {
        goToRoute(name, params) {
            this.$router.push({ name, params });
        },
    },
    computed: {
        background() {
            const GAME = this.$route.params.type;
            const LEVEL = this.$route.params.level;
            if (GAME === 'game1' && LEVEL === '1') return GAME1_LEVEL1_BG;
            if (GAME === 'game1' && LEVEL === '2') return GAME1_LEVEL2_BG;
            if (GAME === 'game1' && LEVEL === '3') return GAME1_LEVEL3_BG;
            return BG;
        },
    },
};
